import React, { useEffect, useState } from "react";
import { IApiFightModel } from "../../util/ApiModel/ApiFightModel";

export function FightLabel(props: IApiFightModel) {
    return <>{props.redFightTeam.name} vs {props.whiteFightTeam.name} {props.type === "additional" ? ` - additional` : ''} ({props.id})</>
}